export default __webpack_public_path__ + "static/media/portfoliobanner.34dc0595.jpg";